if (objects.is_faq){
    let questions = Array.from(document.querySelectorAll(".question"))
    let reponses = Array.from(document.querySelectorAll(".reponse"))

    for (let i=0; i < questions.length; i++){
        questions[i].addEventListener('click', () => {

            if (reponses[i].classList.contains("visible")) {
                reponses[i].classList.remove("visible")
                questions[i].querySelector("svg").style.transform = "rotate(0deg)"
            } else {
                reponses[i].classList.add("visible")
                questions[i].querySelector("svg").style.transform = "rotate(90deg)"
            }
        })
    }
}